import React from 'react';
import Loading from 'components/pure/utils/Loading';
import ArchivingProfileForm from './ArchivingProfileForm';
import EditArchivingProfilePageHelp from './EditArchivingProfilePageHelp';
import noop from 'lodash/noop';
import confirm from 'utils/confirm';
import alert from 'utils/alert';
import {browserHistory} from 'react-router';
import './EditArchivingProfilePage.styl';

const byId = id => o => o.id === id;
const alreadyExists = 'An archiving profile with this name already exists.';
const overwriteWarning = `${alreadyExists} Do you want to overwrite it?`;

export default class EditArchivingProfilePage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onSave = this.onSave.bind(this);
  }
  async onSave() {
    const {department} = this.props.DepartmentFormStore;
    const {archivingProfiles} = this.props.StagingArchivingProfileStore;
    const stagingProfile = archivingProfiles.find(byId(this.props.id));
    const action = stagingProfile.id === null ? 'sendCreateRequest' : 'sendUpdateRequest';
    const sendRequest = shouldOverwrite =>
      this.props.ArchivingProfileActions[action](stagingProfile, shouldOverwrite).then(
        archivingProfile => {
          if (this.props.addToDepartment) {
            this.props.DepartmentActions.updateDepartment(
              department.set('archivingProfileId', archivingProfile.id)
            );
          }
          browserHistory.goBack();
        }
      );

    try {
      await sendRequest(false);
    } catch (e) {
      if (e.response.status === 409) {
        if (!stagingProfile.id) {
          confirm(overwriteWarning).then(() => sendRequest(true), noop);
        } else {
          alert(alreadyExists);
        }
      }
    }
  }
  render() {
    const {
      wasError,
      isLoading,
      archivingProfiles: stagingArchivingProfiles,
      isSaving,
    } = this.props.StagingArchivingProfileStore;

    const stagingProfile = stagingArchivingProfiles.find(byId(this.props.id));
    return (
      <div className="edit-archiving-profile-page">
        {wasError ? (
          'Error fetching profile.'
        ) : isLoading ? (
          <Loading />
        ) : (
          <div>
            <h1>
              {'Archiving Profile - ' + (stagingProfile && stagingProfile.id ? 'Edit' : 'Create')}
            </h1>
            <EditArchivingProfilePageHelp />
            <ArchivingProfileForm
              profile={stagingProfile}
              onChange={this.props.StagingArchivingProfileActions.updateArchivingProfile}
              onCancel={browserHistory.goBack}
              isSaving={isSaving}
              onSave={this.onSave}
            />
          </div>
        )}
      </div>
    );
  }
}
